import React from 'react'
import PropTypes from 'prop-types'
import { PAYMENT_METHOD_TYPES } from 'constants/payment-methods'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { Card } from 'ui-components/Card'
import { CardTitle } from 'ui-components/CardTitle'

export default function BasicInfo({ paymentMethod }) {
  const paymentTypeLabel = () => {
    const type = PAYMENT_METHOD_TYPES.find((item) => (
      item.value === paymentMethod.attributes.payment_type
    ))

    return type?.label || 'não encontrado'
  }

  return (
    <Card>
      <CardTitle title="DADOS BÁSICOS" />
      <DescItemInfo label="Nome">
        {paymentMethod.attributes.name}
      </DescItemInfo>

      <DescItemInfo label="Tipo">
        {paymentTypeLabel()}
      </DescItemInfo>
    </Card>
  )
}

BasicInfo.propTypes = {
  paymentMethod: PropTypes.objectOf(PropTypes.any).isRequired,
}
